<template>
	<div class="editProfile">
		<div class="vx-row">
			<div class="vx-col w-full mb-5">
				<vx-card>
					<h1>{{ $t('profile') }}</h1>
					<div class="row d-flex flex-col sm:flex-row">
						<ProfileImage
							v-model="profile.photo"
							@uploadPhoto="togglePhoto"
							class="mb-5 mr-0 sm:mr-8"
						/>
						<div class="editProfile__inputs mt-10 sm:mt-0">
							<div class="editProfile__input editProfile__name">
								<vs-input :label="$t('personName')" name="name" v-validate="'required|min:3'"
										  v-model="profile.first_name"/>
								<span
									:class="{ 'text-transparent': !errors.first('name') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
							<div class="editProfile__input editProfile__surname">
								<vs-input :label="$t('surname')" name="surname" v-validate="'required|min:3'"
										  v-model="profile.last_name"/>
								<span
									:class="{ 'text-transparent': !errors.first('surname') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div class="editProfile__input editProfile__email">
								<vs-input label="E-Mail" name="email" v-validate="'required|email|min:3'"
										  v-model="profile.email"/>
								<span
									:class="{ 'text-transparent': !errors.first('email') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div class="editProfile__input editProfile__email-rent">
								<vs-input :label="$t('emailForPayment')" name="emailRent"
										  v-model="profile.email_payment"/>
								<span
									:class="{ 'text-transparent': !errors.first('emailRent') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div class="editProfile__input editProfile__nickname">
								<vs-input
									:label="$t('nickname')"
									name="nickname"
									v-validate="'required|min:3'"
									v-model="profile.username"
								/>
								<span
									:class="{ 'text-transparent': !errors.first('nickname') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
							<div class="editProfile__input editProfile__birth-date">
								<div class="vs-component vs-con-input-label vs-input vs-input-primary">
									<label class="vs-input--label">{{ $t('birthDate') }}</label>
									<div class="vs-con-input">
									</div>
									<vs-datepicker
										v-model="profile.birth_date"
										:from="new Date()"
										format="dd.MM.yyyy"
										v-validate="'required'"
										name="date"
									/>
								</div>
								<span
									:class="{ 'text-transparent': !errors.first('date') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div class="editProfile__input editProfile__phone">
								<vs-phone
									:label="$t('phone')"
									name="phone"
									v-validate="'required|min:7|max:14'"
									v-model="profile.phone"
								/>
								<span
									:class="{ 'text-transparent': !errors.first('phone') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div class="editProfile__input editProfile__sex">
								<div class="vs-component vs-con-input-label vs-input vs-input-primary">
									<label class="vs-input--label">{{ $t('sex') }}</label>
									<div class="vs-con-input">
									</div>
									<v-select
										v-model="profile.gender"
										v-validate="'required'"
										:reduce="country => country.id"
										:options="genders"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:clearable="false"
										label="name"
										name="sex"
										class="single-row-select"
									/>
								</div>
								<span
									:class="{ 'text-transparent': !errors.first('sex') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div class="editProfile__input editProfile__country">
								<div class="vs-component vs-con-input-label vs-input vs-input-primary">
									<label class="vs-input--label">{{ $t('country') }}</label>
									<div class="vs-con-input">
									</div>
									<v-select
										v-model="profile.country"
										:reduce="country => country.id"
										:options="countries"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										label="name" v-validate="'required'"
										name="country"
										:clearable="false"
										class="single-row-select"
									/>
								</div>
								<span
									:class="{ 'text-transparent': !errors.first('country') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div class="editProfile__input editProfile__language">
								<div class="vs-component vs-con-input-label vs-input vs-input-primary">
									<label class="vs-input--label">{{ $t('language') }}</label>
									<div class="vs-con-input">
									</div>
									<v-select
										v-model="profile.languages"
										v-validate="'required'"
										:options="languages.map(item => ({ id: item.id, [`name_${locale}`]: item.name}))"
                    :reduce="lang => lang.id"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:label="`name_${locale}`"
										:closeOnSelect="false"
                    multiple
										name="lang"
										data
									/>
								</div>
								<span
									:class="{ 'text-transparent': !errors.first('lang') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div class="editProfile__input editProfile__subjects">
								<div class="vs-component vs-con-input-label vs-input vs-input-primary">
									<label class="vs-input--label">{{ $t('subjects') }}</label>
									<div class="vs-con-input">
									</div>
									<v-select
										v-validate="'required'"
										v-model="profile.subjects"
										:closeOnSelect="false"
										:reduce="subjects => subjects.id" label="name"
										:options="subjects"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										name="subject"
										multiple
										data
									/>
								</div>
								<span
									:class="{ 'text-transparent': !errors.first('subject') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div class="editProfile__input editProfile__about">
								<div class="flex flex-col flex-grow vs-component vs-con-input-label vs-input vs-input-primary">
									<label class="vs-input--label">{{ $t('aboutYourself') }}</label>
									<vs-textarea
										v-model="profile.about"
										name="about"
										v-validate="'required|min:3'"
										class="flex-grow mb-0"
									/>
								</div>
								<span
									:class="{ 'text-transparent': !errors.first('about') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
							<div class="editProfile__input editProfile__level">
								<div class="vs-component vs-con-input-label vs-input vs-input-primary">
									<label class="vs-input--label">{{ $t('level') }}</label>
									<div class="vs-con-input">
									</div>
									<v-select
										v-model="profile.quality_level"
										:reduce="country => country.id" label="level"
										v-validate="'required'"
										name="level"
										:options="levels" :dir="$vs.rtl ? 'rtl' : 'ltr'"
										:clearable="false"
										class="single-row-select"
									/>
								</div>
								<span
									:class="{ 'text-transparent': !errors.first('level') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div v-if="showNativeInput" class="editProfile__input editProfile__native">
								<vs-input
                  :label="$t('pricePerPage')"
                  name="price"
                  v-validate="'required|numeric|min_value:1'"
                  v-model="profile.native_page_price"
                  type="number"
                  autocomplete="none"
                />
								<span
									:class="{ 'text-transparent': !errors.first('price') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>

							<div class="editProfile__input editProfile__old-password">
								<vx-input-group>
									<vs-password
										:label="$t('password')"
										data-vv-validate-on="blur"
										v-validate="'required|min:6|max:32'"
										type="password"
										name="password"
										v-model="oldpassword"
									/>
								</vx-input-group>
								<span
									:class="{ 'text-transparent': !errors.first('password') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
							<div class="editProfile__input editProfile__password">
								<vx-input-group>
									<vs-password
										:label="$t('repeatPassword')"
										data-vv-validate-on="blur"
										v-validate="'required|min:6|max:32'"
										type="password"
										name="repeat-password"
										v-model="newpassword"
									/>
								</vx-input-group>
								<span
									:class="{ 'text-transparent': !errors.first('repeat-password') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
							<div class="editProfile__input editProfile__undesirableSubjects">
								<div class="vs-component vs-con-input-label vs-input vs-input-primary">
									<label class="vs-input--label">{{ $t('undesirableSubjects') }}</label>
									<div class="vs-con-input">
									</div>
									<v-select
										v-model="profile.undesirable_subjects"
										:closeOnSelect="false"
										:reduce="subjects => subjects.id" label="name"
										:options="subjects"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										name="subject"
										multiple
										data
									/>
								</div>
								<span
									:class="{ 'text-transparent': !errors.first('undesirable_subjects') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
							<div class="editProfile__input">
								<vx-input-group>
									<label class="vs-input--label">{{ $t('status') }}</label>
									<div class="vs-con-input">
									</div>
									<v-select
										:label="$t('Status')"
										v-model="profile.status"
										:reduce="item => item.value" label="label"
										v-validate="'required'"
										name="label"
										:options="statuses" :dir="$vs.rtl ? 'rtl' : 'ltr'"
										:clearable="false"
										class="single-row-select"
									/>
								</vx-input-group>
								<span
									:class="{ 'text-transparent': !errors.first('repeat-password') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
							<div class="editProfile__input editProfile__orderLimit">
								<vs-input :label="$t('order_limit')" name="order_limit"
										  v-model="profile.order_limit"
										  v-validate="'required|numeric'"
								/>
								<span
									:class="{ 'text-transparent': !errors.first('order_limit') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
							<div class="editProfile__input">
								<vx-input-group>
									<label class="vs-input--label">{{ $t('type') }}</label>
									<div class="vs-con-input">
									</div>
									<v-select
										:label="$t('type')"
										v-model="profile.type"
										:reduce="item => item.value" label="label"
										v-validate="'required'"
										name="label"
										:options="authorType" :dir="$vs.rtl ? 'rtl' : 'ltr'"
										:clearable="false"
										class="single-row-select"
									/>
								</vx-input-group>
								<span
									:class="{ 'text-transparent': !errors.first('repeat-password') }"
									class="text-danger text-sm"
								>
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
						</div>
					</div>

					<div class="editProfile__input editProfile__level">
						<div class="vs-component vs-con-input-label vs-input vs-input-primary">
							<label class="vs-input--label">{{ $t('description') }}</label>
							<div class="vs-con-input">
							</div>
							<vs-textarea
								v-model="profile.description"
								name="about"
								v-validate="'required|min:3'"
								class="flex-grow mb-0"
							/>
						</div>
						<span
							:class="{ 'text-transparent': !errors.first('level') }"
							class="text-danger text-sm"
						>
									{{ $t('fieldFilledIncorrect') }}
								</span>
					</div>

					<div class="flex flex-end flex-wrap mb-3 my-5">
						<vs-button class="mr-5" @click="editAuthor">{{ $t('save') }}
						</vs-button>
						<vs-button color="warning" type="border" @click="$router.go(-1)">{{ $t('cancel') }}</vs-button>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import ProfileImage from "@/components/ProfileImage";
import notifier from "@/mixins/notifier";
import vSelect from 'vue-select'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
	name: "EditAuthor",
	mixins: [notifier],
	components: {
		ProfileImage,
		datepicker,
		'v-select': vSelect,
	},

	data() {
		return {
			popupActive: false,
			val: '',
			description: '',
			name: '',
			email: '',
			emailRent: '',
			surname: '',
			date: '',
			phone: '',
			sex: '',
			country: '',
			about: '',
			status: '',
			order_limit: '',
			type: '',
			oldpassword: '',
			newpassword: '',
			lang: [],
			subject: [],

			languages: [],
			subjects: [],
			undesirable_subjects: [],
			countries: [],
			levels: [],
			genders: [],
			profile: {},

      showNativeInput: false,
		}
	},

	computed: {
		minDate() {
			return new Date();
		},
		locale() {
			return this.$store.state.locale;
		},
		statuses() {
			return [
				{
					'value': 'new',
					'label': 'New registration',
				},
				{
					'value': 'assign',
					'label': 'Assign',
				},
				{
					'value': 'assign_newbie',
					'label': 'Assign (newbie)',
				},
				{
					'value': 'not_assign',
					'label': 'Do NOT assign',
				},
				{
					'value': 'risk_zone_low',
					'label': 'Risk zone - low',
				},
				{
					'value': 'risk_zone_medium',
					'label': 'Risk zone - medium',
				},
				{
					'value': 'risk_zone_high',
					'label': 'Risk zone - high',
				},
				{
					'value': 'probation',
					'label': 'Probation',
				},
				{
					'value': 'to_be_deleted',
					'label': 'To be deleted',
				},
			];
		},
		authorType() {
			return [
				{
					'value': 'author',
					'label': 'Author',
				},
				{
					'value': 'ki-author',
					'label': 'KI-author',
				},
			];
		},
    qualityLevel() {
      if (this.profile.quality_level) return this.profile.quality_level
      return null
    },
	},

  watch: {
    qualityLevel(val) {
      if (val === 1) {
        this.showNativeInput = true
      } else {
        this.showNativeInput = false
      }
    }
  },

	methods: {
		async togglePhoto(err,file){
			try {
				this.profile.photo = (await this.$http.post('/upload/one', this.$formData({file: file[0]}))).data.data.url;
				this.changePhoto = false;

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async editAuthor(){
			try {
				let formData = {};
				for(let key in this.profile) {
						formData[key] = this.profile[key];
					// if(key !== "languages") {
					// 	formData[key] = this.profile[key];
					// } else {
          //   console.log(formData[key], ' formData[key]');
          //   console.log(this.profile[key].id, ' this.profile[key]');
					// 	formData[key] = this.profile[key].id;
					// }
				}
				if (formData.order_limit !== undefined && formData.order_limit !== '' && formData.order_limit !== null) {
					const numValue = Number(formData.order_limit);

					if (isNaN(numValue) || !/^\d+$/.test(String(formData.order_limit).trim())) {
						this.notifyError(this.$t('fieldFilledIncorrect'));
						return;
					}

					formData.order_limit = parseInt(formData.order_limit, 10);
				} else {
					formData.order_limit = null;
				}
				formData.undesirable_subjects = this.profile.undesirable_subjects;
				formData.password = this.newpassword !== '' ? this.newpassword : undefined;
				formData.password2 = this.oldpassword !== '' ? this.oldpassword : undefined;
				formData.birth_date = moment(formData.birth_date).format("YYYY-MM-DD HH:MM:ss");

				if(this.newpassword !== '' && this.newpassword !== null) {
					formData.password = this.newpassword;
				}
				if(this.oldpassword !== '' && this.oldpassword !== null) {
					formData.password2 = this.oldpassword;
				}

				this.newpassword = null;
				this.oldpassword = null;

				let res = await this.$http.post('/admin/author/update/'+this.$route.params.id,formData);
				this.notifySuccess(this.$t('dataIsSaved'));

				this.$router.back();

			}catch (e) {
				this.notifyError(e.message);
				if(e.errors){
					Object.values(e.errors).forEach(err=>{
						this.notifyError(err);
					})
				}
			}
		},
		async removePhoto(){
			try {
				let res = await this.$http.post('/admin/author/delete-photo/'+this.$route.params.id);
				this.notifySuccess(this.$t('dataIsSaved'));

			}catch (e) {
				this.notifyError(e.message);
			}
		},
	},

	async created () {
		const role = this.$store.state.auth.role;
		const authorId = this.$route.params.id;

		this.profile = 	 (await this.$http.get(`/${role}/author/view/${authorId}`)).data.data;
		this.levels = (await this.$http.get(`/${role}/author/get-quality-level-list`)).data.data;
		this.languages = (await this.$http.get('/settings/get-languages')).data.data;
		this.subjects =  (await this.$http.get(`/settings/get-subjects`)).data.data;

		this.countries = (await this.$http.get('/settings/get-countries')).data.data;
		this.genders =	 (await this.$http.get('/settings/get-genders')).data.data;

		if(this.profile.gender === 0) {
			this.profile.gender = 1
			this.$nextTick(() => this.profile.gender = 0)
		}
    if (this.profile.native_page_price) {
      this.profile.native_page_price = +this.profile.native_page_price
    }
	},
}
</script>

<style lang="scss" scoped>
.editProfile {
	&__inputs {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-template-areas:
			"name surname about about"
			"email email-rent about about"
			"nickname birth-date level level"
			"phone sex old-password password"
			"country language language ."
			"subjects subjects . .";
		width: 100%;
		margin-left: -14px;
		margin-right: -14px;

		@media screen and (max-width: 1499px) {
			grid-template-columns: repeat(3, 1fr);
			grid-template-areas:
				"name surname about"
				"email email-rent about"
				"nickname birth-date level"
				"phone sex old-password"
				"country password ."
				"language language ."
				"subjects subjects .";
		}

		@media screen and (max-width: 991px) {
			grid-template-columns: repeat(2, 1fr);
			grid-template-areas:
				"name surname"
				"email email-rent"
				"nickname birth-date"
				"phone sex"
				"country ."
				"language language"
				"subjects subjects"
				"about about"
				"level level"
				"old-password password";
		}

		@media screen and (max-width: 575px) {
			flex: 1 0 auto;
			grid-template-columns: repeat(1, 1fr);
			grid-template-areas:
				"name"
				"surname"
				"email"
				"email-rent"
				"nickname"
				"birth-date"
				"phone"
				"sex"
				"country"
				"language"
				"subjects"
				"about"
				"level"
				"old-password"
				"password";
			width: auto;
		}
	}

	&__input {
		display: flex;
		flex-direction: column;
		// justify-content: flex-end;
		margin: 0 14px;
	}

	&__name {
		grid-area: name;
	}

	&__surname {
		grid-area: surname;
	}

	&__email {
		grid-area: email;
	}

	&__email-rent {
		grid-area: email-rent;
	}

	&__nickname {
		grid-area: nickname;
	}

	&__birth-date {
		grid-area: birth-date;
	}

	&__phone {
		grid-area: phone;
	}

	&__sex {
		grid-area: sex;
	}

	&__country {
		grid-area: country;
	}

	&__language {
		grid-area: language;
	}

	&__subjects {
		grid-area: subjects;
	}

	&__about {
		grid-area: about;
		flex: 1 0 auto;
		display: flex;
		flex-direction: column;

		.vs-input--label {
			margin-bottom: 4px;
		}

		@media screen and (max-width: 991px) {
			min-height: 180px;
		}
	}

	&__level {
		grid-area: level;
	}

	&__old-password {
		grid-area: old-password;
	}

	&__password {
		grid-area: password;
	}
}
</style>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.editProfile {
	.vs-textarea {
		height: 100%;

		&:focus {
			resize: none !important;
		}
	}

	.vx-input-group .append-text.btn-addon .vs-button {
		height: 2.65rem;
		width: 2.65rem;
		justify-content: center;
		padding: 0 !important;
		margin-top: 20px;
		align-items: center;

		&-text {
			margin-top: 4px;
		}
	}

	.vs-con-input-label {
		width: 100%;
	}

	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}


	table {
		margin-bottom: 20px;
		padding-left: 15px;

		tr {

			td {
				padding-bottom: 7px;

				&:first-child {
					width: 250px;
					font-weight: 600;
				}
			}

		}
	}

	.photo {
		width: 170px;
		height: 150px;
		border-radius: 10px;
		overflow: hidden;
		margin: 15px 0 ;
		flex-shrink: 0;
		.con-input-upload,.img-upload{
			width: 100%;
			margin: 0;
			height: 100%;
		}
		.con-img-upload{
			height: 100%;
		}
		.con-upload{
			height: 100%;
		}
		img {
			max-width: 100%;
			margin: 0 auto;
			width: 100%;
			height: 100%;
		}
	}

	.info {
		width: 170px;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		margin-right: 30px;
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}
}
</style>
